/*
  Used to map parse data in TableFilter,
  because a field could be has 2 operations
*/

const parseFilterDataMapping = {
    'vehicle_id': 'vehicle.id:in',
    'box_type_id': 'box_type.id:in',
};

export default parseFilterDataMapping;
